import { ChangeCardNickNameSchemaInput } from 'Validations';

export const onChangeRegisterCardNickNameNormalize = (
  values: ChangeCardNickNameSchemaInput,
  mifareId: string,
  customerNumber?: number,
  sessionToken?: string
) => {
  const formValues = {
    CustomerNumber: customerNumber,
    SessionToken: sessionToken,
    MifareId: mifareId,
    NickName: values.cardNickName.trim(),
  };
  return formValues;
};
